import { render, staticRenderFns } from "./chart6.vue?vue&type=template&id=271fa4d4&scoped=true"
import script from "./chart6.vue?vue&type=script&lang=js"
export * from "./chart6.vue?vue&type=script&lang=js"
import style0 from "./chart6.vue?vue&type=style&index=0&id=271fa4d4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "271fa4d4",
  null
  
)

export default component.exports